import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { CheckoutComponent } from './paynow/checkout/checkout.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './services/auth-guard';
import { TestComponent } from './paynow/test/test.component';
import { ErrorComponent } from './paynow/error/error.component';
import { ReceiptComponent } from './paynow/receipt/receipt.component';
import { ExpiredComponent } from './expired/expired.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { PaymentErrorComponent } from './paynow/payment-error/payment-error.component';
import { SessionExpiredComponent } from './sessionExpired/session-expired.component';



const routes: Routes = [
    { path: 'paynow/:token', component: LoginComponent },
    { path: 'expired', component: ExpiredComponent },
    { path: 'notfound', component: NotFoundComponent },
    {
      path: '',
      component: AppLayoutComponent,  // Use AppLayoutComponent as the layout
      canActivate: [AuthGuard], // Apply AuthGuard to all routes inside the layout
      children: [
        { path: 'checkout', component: CheckoutComponent, data: { title: 'Checkout' } },
        { path: 'test', component: TestComponent, data: { title: 'Test' } },
        { path: 'error', component: ErrorComponent, data: { title: 'Error' } },
        { path: 'receipt', component: ReceiptComponent, data: { title: 'Receipt' } },
        { path: 'paymentError', component: PaymentErrorComponent, data: { title: 'Payment Error' } },
        { path: 'sessionExpired', component: SessionExpiredComponent, data: { title: 'Session Expired' } },
      ]
    },
    { path: '**', redirectTo: 'notfound' }
  ];

  @NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }
